import { render, staticRenderFns } from "./SignReward.vue?vue&type=template&id=259707b6&scoped=true&"
import script from "./SignReward.vue?vue&type=script&lang=js&"
export * from "./SignReward.vue?vue&type=script&lang=js&"
import style0 from "./SignReward.vue?vue&type=style&index=0&id=259707b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259707b6",
  null
  
)

export default component.exports